import { defineMessages } from 'react-intl'

export default defineMessages({
  name: {
    id: 'OrganizationToolbarsPage.Instance.name',
    defaultMessage: 'Client Name'
  },
  description: {
    id: 'OrganizationToolbarsPage.Instance.description',
    defaultMessage: 'Description'
  },
  creation: {
    id: 'OrganizationToolbarsPage.Instance.creation',
    defaultMessage: 'Creation Details'
  },
  delete: {
    id: 'OrganizationToolbarsPage.Instance.delete',
    defaultMessage: 'Delete Client Credentials?'
  },
  title: {
    id: 'OrganizationToolbarsPage.Instance.title',
    defaultMessage: 'Clients'
  },
  toolbarsLowerCase: {
    id: 'OrganizationToolbarsPage.Instance.toolbarsLowerCase',
    defaultMessage: 'clients'
  },
  cancel: {
    id: 'OrganizationToolbarsPage.Instance.Cancel',
    defaultMessage: 'Cancel'
  },
  confirmDelete: {
    id: 'OrganizationToolbarsPage.Instance.ConfirmDeleteInputLabel',
    defaultMessage: 'Type "Delete" to confirm this action:'
  },
  deleteButton: {
    id: 'OrganizationToolbarsPage.Instance.ConfirmDeleteToolbarButton',
    defaultMessage: 'Delete Client'
  },
  deleteMenuButton: {
    id: 'OrganizationToolbarsPage.Instance.DeleteToolbarMenuButton',
    defaultMessage: 'Delete Client'
  },
  subMessage: {
    id: 'OrganizationToolbarsPage.Instance.ConfirmDeleteSubMessage',
    defaultMessage:
      'This is an unrecoverable action. Removing these credentials will prevent authentication with any clients using them.'
  },
  warning: {
    id: 'OrganizationToolbarsPage.Instance.ConfirmDeleteWarning',
    defaultMessage: 'You are about to delete the {name} client.'
  }
})
